import store  from '@/utils/store'
export const columns = (vm) =>{
    return [
        {
            type: 'index',
            width: 50,
            label: '序号',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'订单号',
            prop:'outTradeNo',
            align:'left',
            headerAlign:'left',
            tooltip:true,
        },
        {
            label:'产品名称',
            prop:'productName',
            align:'center',
            headerAlign:'center',
            tooltip:true,
        },

        {
            label:'序列号/IMEI',
            prop:'serialNo',
            align:'center',
            headerAlign:'center',
            width:160,
          
        },
        {
            label:'项目名称',
            prop:'projectName',
            align:'left',
            headerAlign:'left',
        },
        {
            label:'位置区域',
            prop:'address',
            align:'left',
            headerAlign:'left',
        },
        {
            label:'平台费时长(天)',
            prop:'availableTime',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'单价（元）',
            prop:'totalAmount',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'操作人员',
            prop:'recharger',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'续费开始时间',
            prop:'startTime',
            align:'center',
            headerAlign:'center',
            width:120
        },
		{
		    label:'续费结束时间',
		    prop:'endTime',
		    align:'center',
		    headerAlign:'center',
		    width:120
		},
        
    ]
}